import { createStyles } from 'antd-style'

import { ROW_HOVER_CONCEAL_CLASS, ROW_HOVER_REVEAL_CLASS } from '../config'

export const useStyles = createStyles(({ token }) => {
  const revealed = {
    [`.${ROW_HOVER_REVEAL_CLASS}`]: { display: 'inline-flex' },
    [`.${ROW_HOVER_CONCEAL_CLASS}`]: { display: 'none' }
  }

  return {
    row: {
      minHeight: token.controlHeight,
      marginInline: token.marginXXS,
      paddingInline: token.paddingXS,
      borderRadius: token.borderRadius,
      cursor: 'pointer',
      userSelect: 'none',
      transition: `background-color ${token.motionDurationFast} ${token.motionEaseOut}`,
      [`.${ROW_HOVER_REVEAL_CLASS}`]: { display: 'none' },
      '&:hover': {
        backgroundColor: token.controlItemBgHover,
        ...revealed
      },
      '&:focus-within': revealed,
      '&[data-dnd-dragging]': {
        border: 'none',
        outline: 'none',
        paddingBlock: 0,
        backgroundColor: token.colorBgElevated,
        boxShadow: token.boxShadowSecondary,
        cursor: 'grabbing',
        ...revealed
      },
      '&&[data-dnd-placeholder]': {
        visibility: 'visible',
        backgroundColor: token.colorPrimaryBg,
        outline: `${token.lineWidth}px dashed ${token.colorPrimary}`,
        outlineOffset: -token.lineWidth,
        '& > *': {
          visibility: 'hidden'
        }
      }
    },
    locked: {
      cursor: 'default'
    },
    grip: {
      flex: 'none',
      color: token.colorTextSecondary,
      cursor: 'grab',
      touchAction: 'none',
      borderRadius: token.borderRadiusXS,
      '&:focus': {
        outline: 'none'
      },
      '&:focus-visible': {
        outline: `3px solid var(--brand-teal-soft)`
      },
      '[data-dnd-dragging] &': {
        outline: 'none'
      }
    },
    icon: {
      flex: 'none',
      color: token.colorTextSecondary
    },
    title: {
      flex: 1,
      minWidth: 0
    },
    titleText: {
      minWidth: 0
    }
  }
})
